import { Box, Heading, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { useI18n } from 'lib/i18n/context';

import ChartsWidgetsList from '../stats/ChartsWidgetsList';
import { STATS_KEYS } from '../stats/i18n';
import NumberWidgetsList from '../stats/NumberWidgetsList';
import StatsFilters from '../stats/StatsFilters';
import useStats from '../stats/useStats';

const Stats = () => {
  const { t } = useI18n();
  const {
    isPlaceholderData,
    isError,
    sections,
    currentSection,
    handleSectionChange,
    interval,
    handleIntervalChange,
    handleFilterChange,
    displayedCharts,
    filterQuery,
    initialFilterQuery,
  } = useStats();

  const titleColor = useColorModeValue('#000000', '#FFFFFF');

  return (
    <Box>
      <Heading
        as="h1"
        fontSize="24px"
        fontWeight={ 600 }
        fontFamily="'Space Grotesk', sans-serif"
        color={ titleColor }
        mb={ 6 }
      >
        { t(config.meta.seo.enhancedDataEnabled ? STATS_KEYS.title.enhancedData : STATS_KEYS.title.default, { chainName: config.chain.name }) }
      </Heading>

      <Box mb={ 6 }>
        <NumberWidgetsList/>
      </Box>

      <Box mb={ 6 }>
        <StatsFilters
          isLoading={ isPlaceholderData }
          initialFilterValue={ initialFilterQuery }
          sections={ sections }
          currentSection={ currentSection }
          onSectionChange={ handleSectionChange }
          interval={ interval }
          onIntervalChange={ handleIntervalChange }
          onFilterInputChange={ handleFilterChange }
        />
      </Box>

      <ChartsWidgetsList
        filterQuery={ filterQuery }
        initialFilterQuery={ initialFilterQuery }
        isError={ isError }
        isPlaceholderData={ isPlaceholderData }
        charts={ displayedCharts }
        interval={ interval }
      />
    </Box>
  );
};

export default Stats;
